import { useEffect } from 'react';
import { playSound } from '../assets/preloadSounds';
import type { SoundId } from '../assets/soundCatalog';

/** Play once when the component mounts (success/fail screens, etc.). */
export function usePlaySoundOnMount(id: SoundId): void {
  useEffect(() => {
    playSound(id);
  }, [id]);
}
